<!--
 * @Author: MouXiaowei
 * @Date: 2022-05-26 14:24:02
 * @Description: 邮储银行数字人民币红包活动-活动结果页
-->
<template>
  <div class="home-box">
    <div class="content-box">
      <div class="content-box-content">
        <div class="title-view">恭喜您获得红包</div>
        <div class="redpaper-bg">
          <div class="amount-view">
            <div class="amount-view-left">
              <div class="amount-view-left-tag">¥</div>
              <div class="amount-view-left-value">{{redAmount}}</div>
            </div>
            <div class="amount-view-right">红包金额</div>
          </div>
          <div class="phone-view">{{'参与手机号：' + secretMobile}}</div>
        </div>
        <div class="tip-box">
          <p class="tip-box-value">请通过应用市场下载最新版数字人民币APP（开发者：中国人民银行数字货币研究所），使用参与报名的同一手机号开通邮储银行数字人民币钱包。</p>
          <p class="tip-box-value">红包到账情况可通过数字人民币APP查看，请在有效时间内使用。</p>
        </div>
      </div>
    </div>
    <div class="digiccy-box">
      <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_digiccy_btn1_green.png" @click="goApp">
    </div>
    <div class="open-box" @click="gotoOpenExplainPage">钱包开通及红包查看说明</div>
    <div class="redpaper-box" @click="gotoRedpaperExplainPage">红包使用说明</div>
    <div class="logo-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_logo.png">
    </div>
  </div>
</template>
<script>

import { queryPSBCDigiccyRedRet } from '@/api/active'

export default {
  components: {

  },
  data () {
    return {
      redAmount: '',
      secretMobile: ''
    }
  },
  mounted () {
    this.redAmount = this.$route.query.redAmount
    this.secretMobile = this.$route.query.secretMobile
  },
  methods: {
    queryRedRet () {
      const queryList = {
      }
      queryPSBCDigiccyRedRet(queryList).then(res => {
        if (res && res.data) {
          const datas = res.data.result
          this.phone = datas.mobile
          this.state = datas.state
        }
      })
    },
    gotoOpenExplainPage () {
      this.$router.push('/psbcOpenExplain')
    },
    gotoRedpaperExplainPage () {
      this.$router.push('/psbcRedparperExplain')
    },
    // 跳转数字人民币APP
    goApp () {
      dsBridge.call('callNativeViewLifeCycle', {
        androidGoPage: 'https://pilot.app.ecny.pbcdci.cn/download/index.html',
        iosGoPage: 'https://pilot.app.ecny.pbcdci.cn/download/index.html',
        appId: '',
        appType: 4,
        appName: '邮储银行数币红包活动',
        appStartUrl: 'https://pilot.app.ecny.pbcdci.cn/download/index.html'
      })
      // setTimeout(function () {
      //   window.location.href = 'https://pilot.app.ecny.pbcdci.cn/download/index.html'
      // }, 1200)
    }
  }
}
</script>
<style lang="scss" scoped>
.home-box {
  position: relative;
  min-height: 100vh;
  background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_bg1_green.png') no-repeat;
  background-size: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}
.content-box {
  margin-top: 60%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.content-box-content {
  height: 270px;
  width: 336px;
  background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_redpaper_bg1_green.png') no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title-view {
    margin-top: 18.5px;
    color: #4A4A4A;
    font-size: 17px;
    line-height: 24px;
    font-weight: bold;
    text-align: center;
  }

  .tip-box {
    font-size: 12px;
    color: #4B4B4B;
    line-height: 18px;
    p {
      margin: 15px 28.5px;
    }
  }

  .redpaper-bg {
    margin-top: 7.5px;
    height: 80px;
    width: 200px;
    background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_redpaper.png') no-repeat;

    .amount-view {
      height: 54px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .amount-view-left {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: center;
        .amount-view-left-tag {
          font-weight: 400;
          font-size: 15px;
          color: #FFDCA8;
          letter-spacing: -0.84px;
          text-shadow: 0 1px 3px #DD2D14;
          line-height: 15px;
        }
        .amount-view-left-value {
          margin-left: 2px;
          font-weight: 500;
          font-size: 28px;
          color: #FFDCA8;
          letter-spacing: 0;
          text-shadow: 0 2px 3px #DD2D14;
          line-height: 28px;
        }
      }
      .amount-view-right {
        width: 100px;
        font-weight: 400;
        font-size: 12px;
        color: #FFF6E2;
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
      }
    }
    .phone-view {
      height: 26px;
      font-weight: Bold;
      font-size: 12px;
      color: #F03632;
      letter-spacing: 0;
      line-height: 26px;
      text-align: center;
    }
  }
}
.digiccy-box {
  margin-top: 17.5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.open-box {
  margin-top: 20px;
  margin-left: 30px;
  font-weight: 500;
  font-size: 12px;
  color: #189435;
  letter-spacing: 0;
  text-decoration: underline;
}
.redpaper-box {
  margin-top: 20px;
  margin-left: 30px;
  padding-bottom: 20px;
  font-weight: 500;
  font-size: 12px;
  color: #189435;
  letter-spacing: 0;
  text-decoration: underline;
}
.logo-box {
    margin-top: 24.5px;
    min-height: 180px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    img {
        width: 100%;
    }
}
</style>
